import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { QuickLoanService } from "src/app/_QuickLoan/services/quickLoan.service";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { EncrDecrService } from "src/app/AuthGuard/EncrDecrService";
import { DialogService } from "src/app/Shared/dialog.service";
import { MasterService } from "../../Shared/app.Masters.Service";
import * as FileSaver from 'file-saver';


declare var $: any;

import { ActivatedRoute, Router, ParamMap } from "@angular/router";
import { SnackbarComponent } from "src/app/snackbar/snackbar.component";
import { LmsService } from "../services/lms.service";

@Component({
    selector: "app-lms-sanction-condition",
    templateUrl: "./lms-sanction-condition.component.html",
    styleUrls: ["./lms-sanction-condition.component.scss"],
    standalone: false
})
export class LmsSanctionConditionComponent implements OnInit {
  @Input() loanSummary: any;

  showSpinner: boolean = false;
  PageId: any = null;
  Value: any = "Add";
  BtnValue: any = "Save";

  SanctionConditionsDetails: any = [];
  SanctionConditionsData: any;
  loading: boolean = false;
  Headers: any = [];
  Id: any = 0;
  VoucherId: string;
  LoanId: string;
  currentUser: any;
  Header: string;
  PageAcess: any;
  dataSourceEsign: any;
  displayedColumnsEsign: string[] = [];
  paginatorRef: MatPaginator;
  @ViewChild("paginatorRef")
  set paginator(value: MatPaginator) {
    this.paginatorRef = value;
    if (this.dataSourceEsign) {
      this.dataSourceEsign.paginator = this.paginatorRef;
    }
  }
  dataUrl: string;
    isSignzyEnabled: boolean = false;
     EsignVendor: any = { VendorName: "" };
  VKYCVendor: any = { VendorName: "" };
  VKYC_Template: any;
esignResponse: any = null;
VKYCData: any = null;
ShowKYCData : boolean = false;
token: string;
consumerId: string;
  copied = false;



  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  @Output() action: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private _Route: Router,
    private activedRoute: ActivatedRoute,
    private dataSharingService: DataSharingService,
    public snackBar: MatSnackBar,
    private LmsService: LmsService,
    private DecriptService: EncrDecrService,
    private dialog: DialogService,
    private _QuickLoanService: QuickLoanService,
    private _EncrDecrService: EncrDecrService,
    private MasterService: MasterService,
    private route: ActivatedRoute // private lmsService: LmsService
  ) {
    this.route.paramMap.subscribe((param: ParamMap) => {
      this.LoanId = decodeURIComponent(param.get("id"));
      this.VoucherId = this._EncrDecrService.decrypt(
        decodeURIComponent(param.get("vid"))
      );
      this.PageId = decodeURIComponent(param.get("page"));

      let AllPage = JSON.parse(sessionStorage.getItem("AllPageAcess"));
      this.PageAcess = AllPage.filter(
        (x) => x.Page_Name == "Sanction Conditions"
      );

      
    });
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
this.MasterService.Get_Sms_Configration({ Step_Name: "E-Sign" }).subscribe((res: any) => {
      if (res && Array.isArray(res) && res.length > 0) {
        this.EsignVendor = res[0];
        const vName = (res[0].VendorName || res[0].Vendor_Name || res[0].Vendor || "").toString().toLowerCase();
        if (vName.includes("signzy")) {
          this.isSignzyEnabled = true;
          console.log("isSignzyEnabled:", this.isSignzyEnabled);
        }
      }
    });
    this.MasterService.Get_Sms_Configration({ Step_Name: "VKYC" }).subscribe((res: any) => {
      if (res && Array.isArray(res) && res.length > 0) {
        this.VKYCVendor = res[0];
        const vName = (res[0].VendorName || res[0].Vendor_Name || res[0].Vendor || "").toString().toLowerCase();
        if (vName.includes("signzy")) {
          this.VKYC_Template = this.VKYCVendor.TemplateId;
        }
      }
    });
    this.GetSanctionConditions();
    this.getLoanDetailsByLoanid();
        this.Get_Signzy_Esign_Request_Response();
        this.Get_Signzy_VKYC_Request_Response();

    
  }
  get hasVkycResult(): boolean {
  const raw = this.VKYCData?.[0]?.CallBackDataResponse;
  if (!raw) return false;
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
    return !!parsed?.result;
  } catch {
    return false;
  }
}
get vkycResult(): any {
  const raw = this.VKYCData?.[0]?.CallBackDataResponse;
  if (!raw) return null;
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
    return parsed?.result || null;
  } catch {
    return null;
  }
}

get videoUrl(): string | null {
  if (this.VKYCData && this.VKYCData.length > 0) {
    try {
      const resp = typeof this.VKYCData[0].Response === 'string'
        ? JSON.parse(this.VKYCData[0].Response)
        : this.VKYCData[0].Response;
      return resp?.videoUrl || null;
    } catch (e) {
      console.error('Error parsing VKYC response', e);
      return null;
    }
  }
  return null;
}
  Get_Signzy_Esign_Request_Response() {
      this.MasterService.Get_Signzy_Esign_Request_Response({
        LoanId: this.loanSummary.LoanId,
      }).subscribe((res: any) => {
        console.log("Get_Signzy_Esign_Request_Response", res);
        this.esignResponse = Array.isArray(res) && res.length ? res[0] : res;
      });
    }
    Get_Signzy_VKYC_Request_Response() {
       this.VKYCData = null; // clear old state first
      this.ShowKYCData = false;
      this.MasterService.Get_Signzy_VKYC_Request_Response({
        LoanId: this.loanSummary.LoanId,
      })
      .subscribe((res: any) => {
        console.log(res);
        this.VKYCData = res;
        this.token = this.VKYCData[0].Token;
          this.consumerId = this.VKYCData[0].consumerId;
          console.log(this.token)
    
        if(this.hasVkycResult){
          this.ShowKYCData = true;
          console.log("ShowKYCData",this.ShowKYCData)
    
        }else{
          this.ShowKYCData = false;
          console.log("ShowKYCData",this.ShowKYCData)
        }
      });
    }
    ViewVKYCData(){
      $("#signzyVKYCModel").modal("show");
    }
    onCloseSignzyVKYCModal() {
      $("#signzyVKYCModel").modal("hide");
    }
    downloadFile(url: string, filename: string) {
      fetch(url)
        .then(res => {
          if (!res.ok) throw new Error('Network response was not ok');
          return res.blob();
        })
        .then(blob => {
          const blobUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(blobUrl);
        })
        .catch(err => {
          console.error('Download failed:', err);
          // fallback: open in new tab if fetch/blob approach fails (e.g. CORS block)
          window.open(url, '_blank');
        });
    }
      
    
    GetData_VKYC_Signzy() {
      this.MasterService.VKYC_Signzy_GetData({
        token: this.token,
        consumerId: this.consumerId,
        LoanId: this.loanSummary.LoanId,
        LoginUserId: this.currentUser.userId,
        ApplicationNo: this.loanSummary.ApplicationNo
      })
      .subscribe((res: any) => {
        console.log(res);
        if (res?.success === false) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res?.message || "Video KYC Verification Pending",
            ...this.configSuccess,
          });
        }
        this.Get_Signzy_VKYC_Request_Response();
      });
    }
    
    OpenLink() {
      if (this.videoUrl) {
        window.open(this.videoUrl, '_blank');
      }
    }
    CopyLink() {
      if (this.videoUrl) {
        navigator.clipboard.writeText(this.videoUrl).then(() => {
          this.copied = true;
          setTimeout(() => this.copied = false, 2000);
        }).catch(err => {
          console.error('Failed to copy link', err);
        });
      }
    }
 
   getLoanDetailsByLoanid(){
    this.LmsService.LMS_GetLoanDetails({
    Loan_Id: this.loanSummary.LoanId,
    }).subscribe((res: any) => {
       if (res.Item9.length > 0) {
              this.dataSourceEsign = new MatTableDataSource(
                JSON.parse(JSON.stringify(res.Item9))
              );
              this.dataSourceEsign.paginator = this.paginatorRef;
              this.displayedColumnsEsign = ["Id", "Status", "Type", "UploadId", "Action"];
            } else {
              this.dataSourceEsign = null;
            }
          });
        }

    checkStatusForEsignAgreement(row) {
      this._QuickLoanService
        .DigioEsignStatusCheck({
          UploadId: row.UploadId,
          LoanId: this.loanSummary.LoanId,
        })
        .subscribe(
          (response: any) => {
  
  
            if (response.length > 0 && response[0].CODE >= 0) {
              if (response[0].MSG == "completed") {
                this.getLoanDetailsByLoanid();
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: "Agreement E-Signed Succesfully.",
                  ...this.configSuccess,
                });
              } else {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: "Agreement E-Sign Request Sent On Mail.",
                  ...this.configSuccess,
                });
              }
            } else {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: response[0].MSG,
                ...this.configSuccess,
              });
            }
          },
          (error) => {
            console.error("Error uploading file:", error);
          }
        );
    }
    async signzyDownloadESignAgreement(row) {
      this.showSpinner = true;
    
      try {
        if (!this.isSignzyEnabled) {
          return;
        }
    
        let url: string | undefined;
    
        try {
          const parsed = typeof row?.Response === 'string'
            ? JSON.parse(row.Response)
            : row?.Response;
    
          url = parsed?.finalSignedContract;
        } catch (err) {
          console.error('Failed to parse row.Response:', err);
          return;
        }
    
        if (!url) {
          console.error('No finalSignedContract found for row:', row);
          return;
        }
    
        const filename = `LoanAgreement_${this.loanSummary.ApplicationNo}_${this.loanSummary.Customer}.pdf`;
    
        const response = await fetch(url);
    
        if (!response.ok) {
          throw new Error(`Download failed with status ${response.status}`);
        }
    
        const blob = await response.blob();
        FileSaver.saveAs(blob, filename);
    
      } catch (err) {
        console.error('Failed to download agreement:', err);
      } finally {
        this.showSpinner = false;
      }
    }
     downloadESignAgreement(row) {
       if (this.isSignzyEnabled) {
      this.signzyDownloadESignAgreement(row);
      return;
    }
    this._QuickLoanService
      .DigioEsignDownload({
        UploadId: row.UploadId,
        LoanId: this.loanSummary.LoanId,
      })
      .subscribe((res: any) => {
        this.blobToBase64Async(res);
        this.saveFile(
          res,
          "LoanAgreement_" +
          this.loanSummary.ApplicationNo +
          "_" +
          this.loanSummary.Customer +
          ".pdf"
        );
      });
  }
  
   blobToBase64Async(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      let $this = this;
      fileReader.onerror = (e) => reject(fileReader.error);

      fileReader.onload = function () {
        $this.dataUrl = fileReader.result.toString().split(";base64,").pop();

        return;
      };
      if (blob) {
        fileReader.readAsDataURL(blob);
      }
    });
  }

  saveFile(blob: Blob, fileName: string) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  addSanctionConditions() {
    this.Id = 0;
    this.Header = "";
    this.SanctionConditionsDetails = [];
    this.initializeDetail();
    $("#SanctionConditions").modal("show");
    $("#SanctionConditions").css("z-index", "1050");
  }
  onCloseSanctionConditions() {
    $("#SanctionConditions").modal("hide");
  }
  initializeDetail() {
    this.SanctionConditionsDetails.push({
      SanctionDetail_Id: 0,
      Detail: "",
    });
  }
  addMoreData() {
    this.initializeDetail();
  }
  removeData(index: any) {
    var item = this.SanctionConditionsDetails[index];
    if (item.SanctionDetail_Id > 0) {
      this._QuickLoanService
        .QuickLoan_Delete_Sanction_Conditions({
          Loan_Id: this.loanSummary.LoanId,
          Id: 0,
          SanctionDetail_Id: item.SanctionDetail_Id,
        })
        .subscribe((response: any) => {
          if (response[0].CODE >= 0) {
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: response[0].MSG,
              ...this.configSuccess,
            });
          }
        });
    }
    this.SanctionConditionsDetails.splice(index, 1);
  }
  OnSaveSanctionConditions() {
    this.onCloseSanctionConditions();
    this.showSpinner = true;
    var Details = { Data: this.SanctionConditionsDetails };
    // console.log("SanctionConditionsDetails", JSON.stringify(Details));
    this._QuickLoanService
      .QuickLoan_Save_Sanction_Conditions({
        JSON: JSON.stringify(Details),
        Header: this.Header,
        Loan_Id: this.loanSummary.LoanId,
        LoginUserId: this.currentUser.userId,
        Id: this.Id,
      })
      .subscribe((response: any) => {
        //console.log(response);
        if (response[0].CODE >= 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
          this.GetSanctionConditions();
          // this.QuickLoan_Save_PageProcess("Sanction Conditions");
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
        }
        this.showSpinner = false;
      });
  }

  GetSanctionConditions() {
    this.Headers = [];
    this._QuickLoanService
      .QuickLoan_Get_Sanction_Conditions({ Loan_Id: this.loanSummary.LoanId })
      .subscribe((response: any) => {
        // console.log(response);
        if (response.length > 0) {
          this.SanctionConditionsData = response;
          this.SanctionConditionsData.forEach((obj: any) => {
            if (
              this.Headers &&
              this.Headers.find((result) => result.Id === obj.Id)
            ) {
              this.Headers.find(
                (result) => result.Id === obj.Id
              ).Condition.push({
                SanctionDetail_Id: obj.SanctionDetail_Id || 0,
                Detail: obj.Detail,
              });
            } else {
              this.Headers.push({
                Id: obj.Id,
                Header: obj.Particulars,
                IsCompleted: obj.Is_Completed,
                Condition: [{
                  SanctionDetail_Id: obj.SanctionDetail_Id || 0,
                  Detail: obj.Detail,
                }],
              });
            }
          });
        }
      });
    // console.log("Header", this.Headers);
  }

  OnEditSanctionConditions(vdData) {
    this.Header = "";
    this.SanctionConditionsDetails = [];
    this.BtnValue = "Edit";
    this.Id = vdData.Id;
    this.Header = vdData.Header;
    vdData.Condition.forEach((obj: any) => {
      this.SanctionConditionsDetails.push({
        SanctionDetail_Id: obj.SanctionDetail_Id || 0,
        Detail: obj.Detail,
      });
    });
    $("#SanctionConditions").modal("show");
    $("#SanctionConditions").css("z-index", "1050");
  }
  OnDeleteSanctionDetail(SanctionDetail_Id) {
    this.dialog
      .openConfirmDialog(`Are you sure you want to Delete this Sanction Condition Detail.`)
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult == false) {
          return;
        } else {
          this._QuickLoanService
            .QuickLoan_Delete_Sanction_Conditions({
              Loan_Id: this.loanSummary.LoanId,
              Id: 0,
              SanctionDetail_Id: SanctionDetail_Id,
            })
            .subscribe((response: any) => {
              if (response[0].CODE >= 0) {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: response[0].MSG,
                  ...this.configSuccess,
                });
                this.GetSanctionConditions();
              } else {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: response[0].MSG,
                  ...this.configSuccess,
                });
              }
            });
        }
      });
  }
  OnDeleteSanctionConditions(Id) {
    this.dialog
      .openConfirmDialog(`Are you sure you want to Delete Sanction Conditions.`)
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult == false) {
          return;
        } else {
          this._QuickLoanService
            .QuickLoan_Delete_Sanction_Conditions({
              Loan_Id: this.loanSummary.LoanId,
              Id: Id,
              SanctionDetail_Id: 0,
            })
            .subscribe((response: any) => {
              // console.log(response);
              if (response[0].CODE >= 0) {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: response[0].MSG,
                  ...this.configSuccess,
                });
                this.GetSanctionConditions();

                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: response[0].MSG,
                  ...this.configSuccess,
                });
              } else {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: response[0].MSG,
                  ...this.configSuccess,
                });
              }
            });
        }
      });
  }


  onNext() {
    this.LmsService.SaveNext_Loan({
      Loan_Id: this.loanSummary.LoanId,
      CommandName: "Sanction Condition",
      isStatus: 1,
    }).subscribe((response) => {
      this.action.emit("next");
    });
  }
}
